import { Link } from "react-router-dom";

// Legal links footer — rendered at the very bottom of the landing page, below the command deck.
export function LegalFooter() {
  return (
    <footer className="relative z-20 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 bg-[#05070E] px-5 pb-8 pt-6 text-xs text-bloq-muted" data-testid="lander-legal-footer">
      <Link to="/privacy" className="transition-colors hover:text-white" data-testid="lander-privacy-link">Privacy Policy</Link>
      <Link to="/terms" className="transition-colors hover:text-white" data-testid="lander-terms-link">Terms of Service</Link>
      <Link to="/data-security" className="transition-colors hover:text-white" data-testid="lander-security-link">Data Security</Link>
      <Link to="/delete-account" className="transition-colors hover:text-white" data-testid="lander-delete-link">Delete Account</Link>
      <span>© {new Date().getFullYear()} BLOQ Talk</span>
    </footer>
  );
}
